// src/features/game/components/bottomsheets/RewardSuccessSheet.tsx
import React from 'react';
import { Star } from 'lucide-react';

interface RewardSuccessSheetProps {
  reward: number;
  onConfirm: () => void;
}

export const RewardSuccessSheet: React.FC<RewardSuccessSheetProps> = ({ reward, onConfirm }) => {
  return (
    <div className="p-6 space-y-6">
      {/* 캐릭터 */}
      <div className="flex justify-center">
        <img src="/characters/success-bear.png" alt="성공 캐릭터" className="w-32 h-32" />
      </div>

      {/* 타이틀 */}
      <h2 className="text-xl font-bold text-center">보상 획득!</h2>

      {/* 보상 정보 */}
      <div className="flex items-center justify-center gap-2 p-4 bg-yellow-50 rounded-lg">
        <Star className="w-6 h-6 fill-yellow-400 text-yellow-400" />
        <span className="text-2xl font-bold text-yellow-600">+{reward}</span>
      </div>

      {/* 확인 버튼 */}
      <button
        onClick={onConfirm}
        className="w-full py-4 bg-cyan-500 text-white font-bold rounded-xl hover:bg-cyan-600 transition-colors"
      >
        확인
      </button>
    </div>
  );
};
